import { casesFeature } from './cases.reducer'

export const { selectCases, selectExpandedFolderIds } = casesFeature
